module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZBAMAAAA2x5hQAAAAG1BMVEUAAADfEADYHQXYHgXaGwXYHQTYHgXeCADYHgWt9+3FAAAACHRSTlMAENDPMPfwH3BW3PYAAABoSURBVBjTYyAfsAiAKREIz80QRDKaOYB5Qs0gSeEmiBJGDUMgYaEIZEIlIVIwSbAUXLIYJAWXjFBEsrK0tQDBYbSIMETwhJuKmgUQUopAYxFSAiA74VJgOxFSDHBJN0WwCjUHVP+RDwABEBAHJKdXpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 37